import commonTestListFn from "./commonTestListFn";
export default commonTestListFn('PRACTICE_TEST');